export const startOfDay = '06:00 AM';
export const endOfDay = '11:45 PM';
